import { render, staticRenderFns } from "./AttendanceStatistic.vue?vue&type=template&id=2472f848&scoped=true&"
import script from "./AttendanceStatistic.vue?vue&type=script&lang=js&"
export * from "./AttendanceStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceStatistic.vue?vue&type=style&index=0&id=2472f848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472f848",
  null
  
)

export default component.exports